import { nsT, useT } from '../../index';
import type zh from './zh-CN';

export type ErrorStateMessages = typeof zh;
export const useErrorStateT = () => useT<ErrorStateMessages>('errorState');
export const errorStateT = nsT<ErrorStateMessages>('errorState');
